// @flow
export const OPFS_OOO = 30; // 30, ООО - Общество с ограниченной ответственностью
export const OPFS_PAO = 55; //55, ПАО - Публичное акционерное общество
export const OPFS_ZAO = 17; //17, ЗАО - Закрытое акционерное общество
export const OPFS_OAO = 27; //27, ОАО - Открытое акционерное общество
export const OPFS_IP = 110; //18, ИП  - Индивидуальный предприниматель
